import $script from '@/plugins/script'
/**
 * 加载css
 * @param { String } url css链接
 */
export const addCss = (url) => {
  return new Promise((resolve, reject) => {
    const node = document.createElement('link')
    node.rel = 'stylesheet'
    node.type = 'text/css'
    node.href = url
    node.onload = function () {
      resolve()
    }
    document.getElementsByTagName('head')[0].appendChild(node)
  })
}
/**
 * 加载script
 * 依赖$script
 * https://github.com/ded/script.js/
 * @param { String, Array } url script的url
 * @param { Function } cb 加载成功回调
 */
export const addScript = (url, cb) => {
  $script(url, cb)
  return $script
}

export const dateFormat = (date, format) => {
  if (typeof date === 'string' && date.indexOf('T') === -1) {
    date = date.replace(/-/g, '/')
  }
  if (typeof date === 'number') {
    if (date.toString().length === 10) {
      date *= 1000
    }
  }
  date = new Date(date)
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

const getWindowSize = function () {
  // getSize() {
  // winSize(){

  var pageWidth = window.innerWidth
  var pageHeight = window.innerHeight
  if (typeof pageWidth !== 'number') {
    if (document.compatMode == 'number') {
      pageWidth = document.documentElement.clientWidth
      pageHeight = document.documentElement.clientHeight
    } else {
      pageWidth = document.body.clientWidth
      pageHeight = document.body.clientHeight
    }
  }
  return { width: pageWidth > 1080 ? 1080 : pageWidth, height: pageHeight }

  // }
}

export function getQueryString (name) {
  var getRequest = function () {
    var url = window.location.href // 获取url中"?"符后的字串
    url = url.substr(url.indexOf('?'))
    var theRequest = new Object()
    if (url.indexOf('?') != -1) {
      var str = url.substr(1)
      var strs = str.split('&')
      for (var i = 0; i < strs.length; i++) {
        // 就是这句的问题
        theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
        // 之前用了unescape()
        // 才会出现乱码
      }
    }
    return theRequest
  }
  return getRequest()[name]
}
export const isPC = function () {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'
  ]
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }

  if (flag) {
    flag = getWindowSize().width > 768
  }
  return flag
}

export const getUrl = function (router, parms) {
// alert(2);
  var isDev = (process.env.NODE_ENV === 'development')
  var prex = (isDev ? ('/#/' + router) : ('//www.ushknews.com/' + router + '.html'))

  if (!parms) {
    return prex
  }
  if (isDev) {
    for (var key in parms) {
      var list = []
      for (var key in parms) {
        list.push(parms[key])
      }
      prex += ('/' + list.join('/'))
    }
  } else {
    var list = []
    for (var key in parms) {
      list.push(key + '=' + parms[key])
    }

    prex += ('?' + list.join('&'))
  }
  return prex
}

export const cookie = {
  set (sName, sValue, sExpires, spath, sdomain, secure) {
    let sCookie = sName + '=' + encodeURIComponent(sValue)
    let date = new Date()
    date.setTime(date.getTime() + 3600 * 24 * 1000 * 365)
    sExpires = sExpires || date.toGMTString()
    if (sExpires != null) sCookie += '; expires=' + sExpires
    if (spath != null) sCookie += '; path=' + spath
    if (sdomain != null) sCookie += '; domain=' + sdomain
    if (secure != null) sCookie += '; secure=' + secure
    document.cookie = sCookie
  },
  get (sName) {
    let aCookie = document.cookie.split('; ')
    for (var i = 0; i < aCookie.length; i++) {
      var aCrumb = aCookie[i].split('=')
      if (sName === aCrumb[0]) return decodeURIComponent(aCrumb[1])
    }
    return ''
  },
  remove (sName, spath, sdomain) {
    if (this.get(sName)) {
      document.cookie = sName + '=' +
            ((spath) ? ';path=' + spath : '') +
            ((sdomain) ? ';domain=' + sdomain : '') +
            ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
    }
  }
}

/**
 * 本地缓存存取
 */
export const storage = {
  get (name) {
    let value = localStorage.getItem(name)
    if (!value) {
      return null
    }
    try {
      return JSON.parse(value)
    } catch (e) {
      return null
    }
  },
  set (name, value) {
    localStorage.setItem(name, JSON.stringify(value))
  }
}

export const addClass = (ele, cls) => {
  if (ele.classList) {
    ele.classList.add(cls)
  } else if (!hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class') + ' ' + cls)
  }
}

export const removeClass = (ele, cls) => {
  if (ele.classList) {
    ele.classList.remove(cls)
  } else if (hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class').replace(cls, ' '))
  }
}

export const hasClass = (ele, cls) => {
  return ele.getAttribute('class').indexOf(cls) > -1
}

export const debounce = (func, delay) => {
  let timer = null
  return () => {
    let context = this
    let args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}

const replaceContentAndTrimHtml = (content, replaceStr) => {
  let res = content.replace(replaceStr, '')
  if (res.startsWith('<b></b>')) {
    res = res.replace('<b></b>', '').trim()
  }
  if (res.startsWith('<br/>')) {
    res = res.replace('<br/>', '').trim()
  }
  return res
}

export const flashFormat = (item) => {
  const reg = /^(<b>)?(【)(<b>)?(.+?)(<\/b>)?(】)(<\/b>)?/
  const match = item.data.content.match(reg)
  const criticalValue = 6
  if (match && match[0]) {
    if (!item.data.title) {
      // 没有标题时识别中括号内容字数大于等于criticalValue提取成标题
      if (match[4] && match[4].length >= criticalValue) {
        item.data.title = match[4]
        item.data.content = replaceContentAndTrimHtml(item.data.content, match[0])
      }
    }
    // 对识别字数少于criticalValue的提取标签
    if (match[4] && match[4].length < criticalValue) {
      item.data.tag = match[4]
      item.data.content = replaceContentAndTrimHtml(item.data.content, match[0])
    }
  }
  let sourceLink = ''
  if (item.data.source) {
    if (item.data.source_link) {
      sourceLink = `<a class="flash-source cursor-pointer" href="${item.data.source_link}" target="__blank">（${item.data.source}）</a>`
    } else {
      sourceLink = `<a class="flash-source">（${item.data.source}）</a>`
    }
  }
  return item.data.content + sourceLink
}



// WEBPACK FOOTER //
// ./src/commons/utils.js